import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { AssignmentModel } from "../Assignments Model/assignment-data.model";

export class AssignementAcceptedGridModel extends AssignmentModel { 

  attended_flag: any;
  accepted_flag: any;
  student_name:any;
  student_feedback:any;
  student_feedback_date:any;
  trainer_feedback_to_student:any;
  trainer_feedback_to_student_by:any;
  trainer_feedback_to_student_date:any;
  trainer_feedback_to_admin:any;
  attendance_date:any;
  trainer_feedback_to_admin_date:any;
  attendance_by:any;
  file_flag:any;
  student_file_submit:any;
  student_file_submit_date:any;
  display_filename:any;
  score:any;
  score_by:any;
  score_date:any;
  student_ratings:any;
  feedback_flag:any;
  is_assign:any;
  created:any;
  modified:any;
  file_url_path:any;
  status:any;
  isEdit:boolean= false;


}

export class AssignemntAcceptedListingModel extends GridModel<AssignementAcceptedGridModel> { }

export class AssignementAcceptedGridParams extends GridPostParams {
    pageNumber: any = 1;
    pageSize: any = 10;
    search_text: any = '';
    // assignment_id: any = 348;
    timeslot_id: any = 846;
  }